
class MarketSwitcher extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="country_code"]'),
            button: this.querySelector('.market-switcher__button'),
            panel: this.querySelector('.market-switcher__list'),
            items: this.querySelectorAll('.market-switcher__item a')
        };

        this.elements.button.addEventListener('click', this.togglePanel.bind(this));
        this.elements.button.addEventListener('focusout', this.closePanel.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));

        this.elements.items.forEach(item => {
            item.addEventListener('click', this.onItemClick.bind(this));
        });
    }

    closePanel(event) {
        const shouldClose = !event?.relatedTarget ||
            (event.relatedTarget && !this.contains(event.relatedTarget));

        if (shouldClose) {
            this.elements.panel.setAttribute('hidden', true);
            this.elements.button.setAttribute('aria-expanded', 'false');
        }
    }

    togglePanel() {
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded',
            this.elements.panel.hasAttribute('hidden') ? 'false' : 'true'
        );
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') {
            this.closePanel();
            this.elements.button.focus();
        }
    }

    onItemClick(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const countryCode = target.dataset.countryCode;

        if (countryCode) {
            this.elements.input.value = countryCode;
            this.querySelector('form').submit();
        }
    }
}

customElements.define('sls-localization', MarketSwitcher);